import { RootState } from '../..';
import { Contest } from '../../public/contest/types';
import { TopUser } from './types';

export const selectRankData = (state: RootState): TopUser[] => {
    return state.public.rank.topUsers;
};
export const selectContestOfRank = (state: RootState): Contest => {
    return state.public.rank.contestOfRank;
};